// Vocabulário oficial definido pelo CES / Comitê de Equidade (US-99873).
// O value é a chave persistida pelo backend (nome do membro do enum);
// NAO_INFORMADO é estado interno e não é opção exibida ao cidadão.
// A ordem aqui é a ordem do select: "Prefiro não informar" vem primeiro
// (US-102684), já que o campo passou a ser obrigatório.
export const IdentidadeGeneroOptions = [
  {
    value: "PREFIRO_NAO_INFORMAR",
    label: "Prefiro não informar",
    definicao: "Recusa consciente — resposta válida.",
  },
  {
    value: "MULHER_TRANSGENERO",
    label: "Mulher transgênero",
    definicao:
      "Não se identifica com o gênero atribuído ao nascimento; identifica-se com o gênero feminino.",
  },
  {
    value: "HOMEM_TRANSGENERO",
    label: "Homem transgênero",
    definicao:
      "Não se identifica com o gênero atribuído ao nascimento; identifica-se com o gênero masculino.",
  },
  {
    value: "TRAVESTI",
    label: "Travesti",
    definicao:
      "Não se identifica com o gênero registrado ao nascer; identifica-se com o gênero feminino; identidade predominantemente latino-americana.",
  },
  {
    value: "MULHER_CISGENERO",
    label: "Mulher cisgênero",
    definicao:
      "Registrada com sexo feminino ao nascer e identifica-se com o gênero feminino.",
  },
  {
    value: "HOMEM_CISGENERO",
    label: "Homem cisgênero",
    definicao:
      "Registrado com sexo masculino ao nascer e identifica-se com o gênero masculino.",
  },
  {
    value: "NAO_BINARIO",
    label: "Não-Binário",
    definicao:
      "Identidade não representada por nenhum dos dois gêneros (homem/mulher); pode combinar ambos.",
  },
  {
    value: "OUTRO",
    label: "Outro",
    definicao: "Não se identifica com as definições acima (campo aberto).",
  },
];

export const identidadeGeneroLabel = (value, textoOutro) => {
  if (!value || value === "NAO_INFORMADO") return "Não informado";
  if (value === "OUTRO" && textoOutro) return `Outro: ${textoOutro}`;
  const opcao = IdentidadeGeneroOptions.find((o) => o.value === value);
  return opcao ? opcao.label : "Não informado";
};

export default IdentidadeGeneroOptions;
